<div class="container mt-5">
  <div class="row justify-content-center">
    <div class="col-md-8 col-lg-6">
      <!-- data-message-type carries success/error without the E2E suite having to read the
           localised message text (#137 convention). -->
      <div class="alert {{ messageClass }}" role="alert" data-testid="message-display-text"
           [attr.data-message-type]="messageType">
        <strong>{{ messageIcon }}</strong> {{ message }}
      </div>

      <div class="text-center mt-3">
        <button
          class="btn btn-primary"
          (click)="navigateToReturnUrl()"
          type="button">
          {{ returnButtonText }}
        </button>
      </div>
    </div>
  </div>
</div>
